import { fromJS } from 'immutable';

export function request(state) {
    return state.set('liveGame', {
        status: 'IN_PROGRESS'
    });
}

export function finish(state, { liveGame }) {
    return state.set('liveGame', {
        status: 'FINISHED',
        data: liveGame
    });
}

export function error(state) {
    return state.set('liveGame', {
        status: 'ERROR'
    });
}
